export const getSingleFlavorStick = (stick) => {
    const flavorDetails = stick.product?.flavorDetails?.[0];
    return {
        sku: stick.sku,
        name: flavorDetails?.name || stick.flavour_label,
        description: flavorDetails?.description,
        attributes: flavorDetails?.attributes_custom_?.map(({ id, name, sort_order, value }) => ({
            id: +id,
            name,
            sortOrder: +sort_order,
            value,
        })),
        image: {
            url: stick.product?.thumbnail?.url,
        },
    };
};
//# sourceMappingURL=getSingleFlavorStick.js.map